import React from 'react';
import { useFormContext } from 'react-hook-form';
import { useOrderRequestAccountInputQuery } from '../../../../../../../../services';
import { RhSingleAutocomplete } from '../../../../../../../dum';
import { IOrderRequest } from '../../order-request-form';
import { useCalculateProductsTotal } from '../../helpers/use-calculate-products-total';
import { ORDER_REQUEST_PRODUCTS } from '../order-request-products/order-request-products-columns';
import {
    ORDER_REQUEST_FIELD_LABELS,
    shortLabel,
} from '../../../../../../../../helpers';

export function AccountInput() {
    const inputName: keyof IOrderRequest = 'account_id';
    const { data } = useOrderRequestAccountInputQuery();

    const formContext = useFormContext();
    const { calculateProductsTotal } = useCalculateProductsTotal();

    const accounts = data?.getAccounts || [];

    return (
        <RhSingleAutocomplete
            itemText={'name'}
            itemValue={'id'}
            name={inputName}
            label={shortLabel(ORDER_REQUEST_FIELD_LABELS.account_id)}
            options={accounts}
            onChange={() => {
                // Products are scoped to the account catalog, so switching the
                // account invalidates the current picks — reset them.
                formContext.setValue(ORDER_REQUEST_PRODUCTS, []);
                calculateProductsTotal();
            }}
        />
    );
}
